import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";

const aboutJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "玫瑰视频",
      url: "https://meiguishipin.com",
      description: "玫瑰视频汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，高清免费在线观看。",
      foundingDate: "2023",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: "contact@meiguishipin.com",
        availableLanguage: "Chinese",
      },
    },
    {
      "@type": "WebPage",
      name: "关于玫瑰视频",
      url: "https://meiguishipin.com/about",
      isPartOf: { "@type": "WebSite", name: "玫瑰视频", url: "https://meiguishipin.com" },
    },
  ],
};

const testimonials = [
  {
    name: "追剧达人张先生",
    content: "玫瑰视频真的太方便了！以前我要在好几个平台之间切换找剧，现在一个网站就能看到香蕉视频、糖豆视频、小蓝视频、蓝莓视频的所有内容，追剧效率直接翻倍！",
    rating: 5,
  },
  {
    name: "影迷小玲",
    content: "画质真的很清晰，而且完全不缓冲！我之前用其他平台经常卡顿，玫瑰视频的播放体验好太多了。电影资源也很全，最新的院线大片都能找到。",
    rating: 5,
  },
  {
    name: "综艺控老王",
    content: "作为一个综艺爱好者，玫瑰视频的综艺资源让我非常惊喜。小蓝视频的综艺节目更新特别快，每周新节目基本当天就能看到，强烈推荐！",
    rating: 5,
  },
  {
    name: "宝妈陈姐",
    content: "蓝莓视频的少儿内容做得太好了，孩子特别喜欢看上面的动画片。而且画质高清，不用担心影响孩子视力。现在每天放学后都陪孩子一起看。",
    rating: 4,
  },
  {
    name: "动漫迷小林",
    content: "日漫、国漫、欧美动漫应有尽有！玫瑰视频的动漫频道是我每天必看的，更新速度特别快，番剧同步率很高。糖豆视频和小蓝视频的动漫资源都非常丰富。",
    rating: 5,
  },
  {
    name: "退休教师李叔叔",
    content: "年纪大了不太会用复杂的软件，玫瑰视频界面简洁好操作，电视剧资源多，每天更新。我现在每天下午都要看上两集，生活充实多了。",
    rating: 5,
  },
];

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <SEO
        title="关于玫瑰视频 - 品牌介绍 | 高清影视在线观看平台"
        description="玫瑰视频品牌介绍：一个汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频的热门影视资源平台。了解我们的品牌故事、用户口碑和联系方式。"
        keywords="玫瑰视频,关于我们,品牌介绍,影视平台,联系方式"
        canonicalUrl="https://meiguishipin.com/about"
      />

      <Navbar />

      <main className="pt-20 pb-14">
        <div className="max-w-5xl mx-auto">
          <Breadcrumb
            items={[
              { name: "首页", path: "/" },
              { name: "关于我们" },
            ]}
          />

          <div className="px-4 md:px-6">
            <section className="mb-16">
              <div className="text-center mb-10">
                <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-4">
                  关于玫瑰视频
                </h1>
                <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                  一个汇集热门影视资源的在线平台，致力于为广大用户提供高清、免费、流畅的观影体验
                </p>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 md:p-10">
                <h2 className="text-xl font-heading text-foreground-900 mb-6">品牌故事</h2>
                <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
                  <p>
                    玫瑰视频成立于2023年，源于创始团队对影视行业的热爱和对用户需求的深刻理解。在互联网视频平台百花齐放的时代，用户往往需要在多个平台之间切换才能找到想看的影视内容。玫瑰视频的诞生，正是为了解决这一痛点。
                  </p>
                  <p>
                    我们与<strong>香蕉视频</strong>、<strong>糖豆视频</strong>、<strong>小蓝视频</strong>、<strong>蓝莓视频</strong>等优质影视平台深度合作，将分散在各处的影视资源汇聚在一起，让用户在一个网站上就能浏览和观看所有平台的精彩内容。
                  </p>
                  <p>
                    玫瑰视频的名字取意于玫瑰花的美丽与热情——我们希望为用户带来美丽动人的视觉体验，同时传递我们对影视行业的无限热忱。就像玫瑰花香飘万里，我们希望将优质影视内容传递给每一位热爱观影的用户。
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-16">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
                  平台优势
                </h2>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { icon: "ri-vidicon-line", title: "资源丰富", desc: "汇集四大平台5000+影视资源，涵盖电视剧、电影、综艺、动漫等" },
                  { icon: "ri-4k-line", title: "高清画质", desc: "720P/1080P高清画质，部分支持4K超清，观影体验极致流畅" },
                  { icon: "ri-flashlight-line", title: "不缓冲", desc: "先进CDN加速技术，多节点智能调度，告别卡顿和缓冲" },
                  { icon: "ri-refresh-line", title: "每日更新", desc: "新剧上线24小时内同步更新，追剧不等待，精彩不间断" },
                ].map((item) => (
                  <div key={item.title} className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                      <i className={`${item.icon} text-xl text-accent-600`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-500">听听用户们怎么说</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {testimonials.map((t, i) => (
                  <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, idx) => (
                        <i
                          key={idx}
                          className={`text-sm ${idx < t.rating ? "ri-star-fill text-accent-500" : "ri-star-line text-foreground-300"}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      "{t.content}"
                    </p>
                    <p className="text-xs font-medium text-foreground-800">{t.name}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <div className="bg-background-100 rounded-2xl p-6 md:p-10">
                <h2 className="text-xl font-heading text-foreground-900 mb-6">联系我们</h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-500">contact@meiguishipin.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                      <i className="ri-customer-service-line text-accent-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-800 mb-1">客服微信</h3>
                      <p className="text-sm text-foreground-500">meiguishipin_kf</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                      <i className="ri-time-line text-secondary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-800 mb-1">工作时间</h3>
                      <p className="text-sm text-foreground-500">周一至周日 9:00 - 22:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div className="bg-background-100 rounded-2xl p-6 md:p-10">
                <h2 className="text-xl font-heading text-foreground-900 mb-6">合作平台</h2>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {[
                    { name: "香蕉视频", desc: "主打热门电视剧，古装、都市、悬疑应有尽有", color: "bg-accent-500" },
                    { name: "糖豆视频", desc: "侧重电影大片，院线新片、经典老片齐备", color: "bg-primary-500" },
                    { name: "小蓝视频", desc: "综艺和动漫资源丰富，二次元和综艺控首选", color: "bg-secondary-500" },
                    { name: "蓝莓视频", desc: "纪录片和少儿内容，适合全家一起观看", color: "bg-accent-300" },
                  ].map((platform) => (
                    <div key={platform.name} className="bg-background-50 rounded-xl p-5 text-center">
                      <div className={`w-3 h-3 rounded-full ${platform.color} mx-auto mb-3`}></div>
                      <h3 className="text-sm font-semibold text-foreground-800 mb-2">{platform.name}</h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">{platform.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}